import { getText, zeroPad } from 'shared/utils/Text';

import SelectInput from '../SelectInput';

const TimeSelectInput = ({
  unit,
  selectedMomentDate,
  disableBeforeMomentDate,
  onChange,
  ...props
}) => {
  let value, options;
  switch (unit) {
    case 'month':
      value = selectedMomentDate.month();
      options = Array.from({ length: 12 }, (_, i) => (
        <option
          key={i}
          value={i}
          disabled={
            disableBeforeMomentDate && disableBeforeMomentDate.month() > i
          }
        >
          {getText(`month_${i + 1}`)}
        </option>
      ));
      break;
    case 'date':
      value = selectedMomentDate.date();
      options = Array.from(
        { length: selectedMomentDate.daysInMonth() },
        (_, i) => (
          <option
            key={i + 1}
            value={i + 1}
            disabled={
              disableBeforeMomentDate &&
              disableBeforeMomentDate.month() === selectedMomentDate.month() &&
              disableBeforeMomentDate.date() > i + 1
            }
          >
            {i + 1}
          </option>
        ),
      );
      break;
    case 'hour':
      value = selectedMomentDate.hour();
      options = Array.from({ length: 24 }, (_, i) => (
        <option
          key={i}
          value={i}
          disabled={
            disableBeforeMomentDate &&
            disableBeforeMomentDate.month() === selectedMomentDate.month() &&
            disableBeforeMomentDate.date() === selectedMomentDate.date() &&
            disableBeforeMomentDate.hour() > i
          }
        >
          {zeroPad(i)}
        </option>
      ));
      break;
    case 'minute':
      value = selectedMomentDate.minute();
      options = Array.from({ length: 60 }, (_, i) => (
        <option
          key={i}
          value={i}
          disabled={
            disableBeforeMomentDate &&
            disableBeforeMomentDate.month() === selectedMomentDate.month() &&
            disableBeforeMomentDate.date() === selectedMomentDate.date() &&
            disableBeforeMomentDate.hour() === selectedMomentDate.hour() &&
            disableBeforeMomentDate.minute() > i
          }
        >
          {zeroPad(i)}
        </option>
      ));
      break;
    default:
      throw new Error('Unexpected time unit:', unit);
  }

  const onTimeChange = evt => onChange(unit, evt.target.value);

  return (
    <SelectInput value={value} onChange={onTimeChange} {...props}>
      {options}
    </SelectInput>
  );
};

export default TimeSelectInput;
